export const BaseLinePhone = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M17 2.5H7C6.17157 2.5 5.5 3.17157 5.5 4V20C5.5 20.8284 6.17157 21.5 7 21.5H17C17.8284 21.5 18.5 20.8284 18.5 20V4C18.5 3.17157 17.8284 2.5 17 2.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path d="M11.5 18H12.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
  </svg>
);
